import { TextField } from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { panSchema } from "../../utils/validationSchemas";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { getkycDetailsApi } from "../../redux/features/kycDetailsSlice";
import LoadingButton from "@mui/lab/LoadingButton";
import { FaSave } from "react-icons/fa";
import { decryptFields, encryptFields } from "../../utils/kycStatus";
import axiosInstance from "../../utils/axiosInstance";
import Swal from "sweetalert2";

const fields = [
  { id: "panNum", label: "PAN Number" },
  { id: "dob", label: "Date of Birth" },
  { id: "email", label: "Email" },
];

export default function Pan({ kycDetailApiResponse, handleNext }) {
  const dispatch = useDispatch();
  const [panVerifyLoading, setPanVerifyLoading] = useState(false);

  const { values, handleSubmit, handleChange, errors, setValues } = useFormik({
    initialValues: {
      panNum: "",
      dob: "",
      email: "",
    },
    validationSchema: panSchema,
    validateOnMount: false,
    validateOnChange: false,
    validateOnBlur: true,
    onSubmit: async () => {
      await decryptPanApi2();
    },
  });

  const decryptPanApi2 = async () => {
    try {
      setPanVerifyLoading(true);
      let parsedResponse = "";
      // if (values.panNum === "ABCDE0123Z") {
      //   parsedResponse = {
      //     msg: {
      //       Name: "TEST TEST",
      //       NameOnTheCard: "TEST TEST",
      //       PanHolderStatusType: "Individual",
      //       PanNumber: "ABCDE0123Z",
      //       STATUS: "Active",
      //       StatusDescription: "Existing and Valid",
      //       panHolderStatusType: "Individual",
      //       source_id: 2,
      //     },
      //     status: 1,
      //   };
      // } else {
      const response = await axiosInstance.post("/augmont/panVerify", {
        pannumber: values.panNum,
      });
      parsedResponse = JSON.parse(response?.data?.data[0]);

      // }

      const { Name } = parsedResponse?.msg || "";

      if (parsedResponse?.status === 1) {
        const existingUserDetails =
          JSON.parse(localStorage.getItem("userDetails")) || {};

        if (Name) {
          existingUserDetails.name = Name;
        }

        localStorage.setItem(
          "userDetails",
          JSON.stringify(existingUserDetails)
        );

        await PanKYCAPI(parsedResponse);
      } else if (parsedResponse.status === 1014) {
        toast.error("Incorrect PAN");
        return;
      } else if (parsedResponse.status === 9) {
        toast.error("User not found");
        return;
      } else {
        toast.error("unexpected error");
        return;
      }
    } catch (error) {
      console.log("Error:", error);
      Swal.fire({
        icon: "error",
        text: "Something went wrong try again after some time",
      });
    } finally {
      setPanVerifyLoading(false);
    }
  };

  const PanKYCAPI = async (parsedResponse) => {
    const url = `/kyc/pan`;

    try {
      const formattedDob = values.dob
        ? values.dob.split("-").reverse().join("-")
        : ""; // Reverse the date if it's not empty

      const requestBody = {
        msg: {
          ...parsedResponse.msg,
          dob: formattedDob,
          email: values.email,
        },
        status: parsedResponse.status,
      };

      const response = await axiosInstance.post(url, requestBody);

      if (response.status === 200) {
        let userDetails = JSON.parse(localStorage.getItem("userDetails")) || {};

        userDetails = decryptFields(userDetails, ["pan"]);
        userDetails.pan = true;
        userDetails = encryptFields(userDetails, ["pan"]);
        localStorage.setItem("userDetails", JSON.stringify(userDetails));
        dispatch(getkycDetailsApi());
        handleNext("panel2");
        toast.success("PAN details saved");
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };

  const { PanNumber, dob, email } = kycDetailApiResponse?.[0]?.pan?.msg || {};

  useEffect(() => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));

    if (userDetails) {
      setValues({
        panNum: PanNumber || "",
        dob: userDetails.dob || dob || "",
        email: userDetails.email || email || "",
      });
    }
  }, [setValues, kycDetailApiResponse]);

  return (
    <div>
      <form
        onSubmit={handleSubmit}
        style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}
      >
        {fields.map((field) => (
          <TextField
            key={field.id}
            id={field.id}
            label={field.label}
            variant="outlined"
            size="small"
            onChange={(e) => {
              const { id, value } = e.target;
              const updatedValue =
                id === "panNum" ? value.toUpperCase() : value; // Convert PAN to uppercase
              handleChange({ target: { id, value: updatedValue } }); // Pass the updated value to Formik's handleChange
            }}
            value={values[field.id] || ""}
            error={Boolean(errors[field.id])}
            helperText={errors[field.id] || ""}
            type={field.id === "dob" ? (PanNumber ? "text" : "date") : "text"}
            InputProps={{
              readOnly: !!PanNumber, // Conditionally set the read-only property
            }}
            InputLabelProps={{
              shrink: field.id === "dob" ? true : undefined, // Ensure label displays for date field
            }}
            sx={{ marginBottom: 2 }}
          />
        ))}

        {!PanNumber && (
          <div style={{ display: "flex", justifyContent: "end", gap: "1rem" }}>
            <LoadingButton
              type="submit"
              size="small"
              loading={panVerifyLoading}
              loadingPosition="start"
              startIcon={<FaSave color="white" />}
              variant="contained"
              sx={{
                backgroundColor: "#DA2128",
                color: "white",
                "&:hover": {
                  backgroundColor: "#DA2128",
                },
              }}
            >
              Save
            </LoadingButton>
          </div>
        )}
      </form>
    </div>
  );
}
